import moment from 'moment';
import React from 'react';

interface InProgressAlertProps {
    timestamp: null | string;
}
export function InProgressAlert({ timestamp }: InProgressAlertProps) {
    const dt = moment(timestamp);
    const tenDays = moment().subtract(10, 'days');
    const twentyDays = moment().subtract(20, 'days');
    if (dt.isBefore(twentyDays)) {
        return (
            <i
                className="inprogress-alert fa-solid fa-exclamation-circle text-danger"
                title="Action required: Aging > 20 days"
            />
        );
    }
    if (dt.isSameOrBefore(tenDays)) {
        return (
            <i
                className="inprogress-alert fa-solid fa-exclamation-triangle text-warning"
                title="Action required: Aging 10-20 days"
            />
        );
    }
    return null;
}
